export const ERRORS = {
  NOT_FOUND: 'NOT_FOUND',
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
  EXPIRED: 'EXPIRED',
}
